// «Холодильник» (что купили и ещё не закончилось), «что приготовить» и меню на неделю → список покупок.
import { z } from "zod";
import type { HealthLabel } from "./rhythm.ts";

/** Куплено раньше — «давно, проверьте, есть ли ещё». */
export const PANTRY_STALE_DAYS = 14;

export interface PantryItemDto {
  id: string;
  productId: string;
  name: string;
  /** Полезное / обычное / вредное (своя метка семьи, если поправили). */
  health: HealthLabel;
  /** Обычно хватает на столько дней (ритм покупок); null — покупали мало раз. */
  everyDays: number | null;
  /** Через сколько дней обычно покупают снова: 1 и меньше — скоро закончится. */
  dueIn: number | null;
  /** Сколько купили в последний раз, если известно; unit — код единицы списка (kg, l, pcs…). */
  qty: number | null;
  unit: string | null;
  /** YYYY-MM-DD последней покупки. */
  boughtOn: string;
  daysAgo: number;
}

export interface PantryDto {
  /** Скоро закончится: по ритму покупок пора докупать. */
  soon: PantryItemDto[];
  /** Есть дома: свежие покупки, новые сверху. */
  fresh: PantryItemDto[];
  /** Куплено давно — проверьте, есть ли ещё. */
  stale: PantryItemDto[];
  /** Закончилось за последние две недели — купить снова? */
  used: PantryItemDto[];
}

export interface DishIdeaDto {
  name: string;
  /** Что из дома идёт в блюдо. */
  uses: string[];
  /** Чего не хватает — докупить. */
  missing: string[];
  minutes: number;
  /** Как готовить — одной-двумя фразами. */
  how: string;
}

export const SHOPPING_UNITS = ["kg", "g", "l", "pcs", "pack"] as const;
export type ShoppingUnit = (typeof SHOPPING_UNITS)[number];

export interface ShoppingLineDto {
  name: string;
  qty: number | null;
  unit: ShoppingUnit | null;
}

export interface MealPlanDayDto {
  /** YYYY-MM-DD. */
  date: string;
  lunch: string;
  dinner: string;
}

export interface MealPlanDto {
  id: string;
  startsOn: string;
  days: MealPlanDayDto[];
  /** Что докупить на неделю (без того, что есть дома). */
  shopping: ShoppingLineDto[];
  wishes: string | null;
  createdAt: string;
}

export const PantryAddSchema = z.object({ name: z.string().trim().min(1).max(80) });
export const PantryUsedSchema = z.object({ used: z.boolean() });
export const MealPlanRequestSchema = z.object({ wishes: z.string().trim().max(200).nullable().default(null) });
